// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import { IRootState } from './type';
import { reducers } from './reducers';
import { TActiveSessions } from '../../types';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';

const initialState: IRootState = {
  active_sessions: [] as TActiveSessions[],
};

export const slice = createSlice({
  name: STORE_SLICES.ACTIVE_SESSIONS_DATA,
  initialState,
  reducers,
});

const activeSessionsDataActions = slice.actions;

const activeSessionsDataPersistConfig = {
  key: PERSIST_KEYS.ACTIVE_SESSIONS_DATA,
  storage,
};

export { activeSessionsDataActions, initialState };
export default persistReducer(activeSessionsDataPersistConfig, slice.reducer);
